import React, { useState, useEffect } from 'react';

// Shared JMS Studios signature footer. Drops into any studio game; rises into
// view as the player nears the bottom of the page and tucks away otherwise.
// (Later: this is where the "← More games at JMS Studios" link will live.)
function StudioFooter() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrolledToBottom =
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 80;
      setVisible(scrolledToBottom);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return (
    <footer className={`studio-footer ${visible ? 'visible' : ''}`}>
      © {new Date().getFullYear()} <span className="studio-name">JMS Studios</span>
    </footer>
  );
}

export default StudioFooter;
